import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { statesOptions } from "../../constants";
// import { NumberInput } from "../Utility/NumberInput";
import { toast } from "react-toastify";
import {
  generateLocationKey,
  generateLocationString,
  genericValidationTest,
  isValidZipCode,
  selectValidationTest,
} from "../../helpers/utilities";
import {
  CXTStopTypes,
  dedicatedOrderStatuses,
} from "./DedicatedDispatchConstants";
import RequiredStar from "../Utility/FormElements/RequiredStar";

const insertSequenceTypes = {
  first: "First",
  last: "Last",
  specific: "Specific",
};
// const stopTypes = {
//   delivery:{
//     value:"Delivery",
//     label:"Delivery"
//   },
//   pickup:{
//     value:"Pickup",
//     label:"Pickup"
//   },
// }

const initialFormValues = {
  customerName: "",
  address: "",
  city: "",
  // state: defaultState, //we set this dynamically through props
  zip: "",
  insertSequenceType: insertSequenceTypes.last,
  specificInsertSequence: 1,
  totalPartsCost: 0.0,
  totalPartsSale: 0.0,
  totalValue: 0.0,
  notes: "",
  stopType: "",
};
export const AddManualDedicatedStopModal = ({
  show,
  onClose,
  handleAddManualStop,
  defaultState = "TX",
  stops,
  manualOrderCount,
  setManualOrderCount,
  positionHasDepartedHelper, // function that returns true if the position has already departed, false otherwise.
}) => {
  const [formData, setFormData] = useState({
    ...initialFormValues,
    state: defaultState,
  });
  const [positionHasDeparted, setPositionHasDeparted] = useState(false);
  useEffect(() => {
    if (show) {
      if (positionHasDepartedHelper()) {
        // setFormData(prev=>{return {...prev, stopType: CXTStopTypes.pickup.value}}) // Setting to pickup if the driver has departed but NVM, user should always pick themselves. Don't want them to miss that the stop type was set to something they didn't mean it to be set to. Will just disable the delivery option based on departed state
        setPositionHasDeparted(true);
      } else {
        setPositionHasDeparted(false);
      }
    }
  }, [show]);

  // const minSequence =

  const [submissionAttempted, setSubmissionAttempted] = useState(false);
  const handleChangeForm = (e) => {
    const { name, type, value } = e.target;
    setFormData((prev) => {
      if (type === "radio") {
        return { ...prev, insertSequenceType: name };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };
  const handleClose = () => {
    setFormData({ ...initialFormValues, state: defaultState });
    setSubmissionAttempted(false);
    onClose();
  };

  const handleSubmitAddManualStopForm = (e) => {
    e.preventDefault();
    if (!genericValidationTest(formData.customerName)) {
      toast.error("Please enter a valid customer name.");
      setSubmissionAttempted(true);
      return;
    }
    if (!genericValidationTest(formData.address)) {
      toast.error("Please enter a valid address.");
      setSubmissionAttempted(true);
      return;
    }
    if (!genericValidationTest(formData.city, 2)) {
      toast.error("Please enter a valid city.");
      setSubmissionAttempted(true);
      return;
    }
    if (!isValidZipCode(formData.zip)) {
      toast.error("Please enter a valid zip code.");
      setSubmissionAttempted(true);
      return;
    }
    if (formData.stopType === "") {
      toast.error("Please select a stop type.");
      setSubmissionAttempted(true);
      return;
    }
    //Add Validation ***********, empty string validation then address validation
    // const existingManualStops = stops.filter((stop) => stop.isManual === true);
    //This was for the old version of determining manual stop unique id but now we just do it globally
    // const sortedExistingManualStopIds = existingManualStops
    //   .map((existingManualStop) => {
    //     return parseInt(existingManualStop.deliveryId.split("-")[1]);
    //   })
    //   .sort();
    // console.log("manual stop latest indexes", sortedExistingManualStopIds);

    //Used to generate location string/key
    const destinationObject = {
      customerName: formData.customerName,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
    };
    const orderToAssign = {
      deliveryId: "Manual-" + (manualOrderCount + 1), //incremented this below.
      //Moving this to increment globally
      // (sortedExistingManualStopIds[sortedExistingManualStopIds.length - 1]
      //   ? sortedExistingManualStopIds[
      //       sortedExistingManualStopIds.length - 1
      //     ] + 1
      //   : 1),
      invoiceNumber: "Manual",
      customerName: formData.customerName,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      totalValue: formData.totalValue,
      notes: formData.notes,
      isManual: true,
      status: dedicatedOrderStatuses.unSubmitted,
      stopType: formData.stopType,
      locationString: generateLocationString(destinationObject),
      locationStringWithoutName: generateLocationString(
        destinationObject,
        false
      ),
      locationKey: generateLocationKey(destinationObject),
      originalData: {
        // totalPartsCost: formData.totalPartsCost,
        // totalPartsSale: formData.totalPartsSale,
        totalPartsCost: 0.0,
        totalPartsSale: 0.0,
        numberOfParts: 1,
      },
    };
    let successfullyAdded = false;
    if (formData.insertSequenceType === insertSequenceTypes.last) {
      successfullyAdded = handleAddManualStop([orderToAssign], null, true);
    } else if (formData.insertSequenceType === insertSequenceTypes.first) {
      // console.log("MANUAL STOP 0 PASSED FOR SEQUENCE NUMBER");
      successfullyAdded = handleAddManualStop([orderToAssign], null, true, 0);
    } else if (formData.insertSequenceType === insertSequenceTypes.specific) {
      successfullyAdded = handleAddManualStop(
        [orderToAssign],
        null,
        true,
        formData.specificInsertSequence - 1
      );
    }
    //might need to return a flag for handle manual stop as it can fail if the driver has already departed.
    //But I don't like the success message here because it makes me forget I still have to submit.
    if (successfullyAdded) {
      toast.success(
        `Manual stop added for\n${formData.customerName}\n${formData.address} ${formData.city}, ${formData.state} ${formData.zip}.`
      );
      setManualOrderCount((prev) => prev + 1);
      handleClose();
    }
  };

  const handleOnInvalid = () => {
    setSubmissionAttempted(true);
  };

  // console.log("manual stops length", stops?.length);
  return (
    <Modal show={show} onHide={handleClose} size="lg" backdrop="static">
      <form
        onSubmit={handleSubmitAddManualStopForm}
        onInvalid={handleOnInvalid}
      >
        <Modal.Header closeButton style={{ alignItems: "center" }}>
          <Modal.Title>Adding Manual Stop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>
            Destination
            <RequiredStar />
          </h5>
          <div className="form-row">
            <DiliTextCP
              placeholder="Customer Name"
              className="col-md-8 mb-2"
              name="customerName"
              required
              // minLength={3}
              value={formData.customerName}
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
              validationTest={genericValidationTest}
              problemText={"Please enter a valid customer name."}
              showProblemText={
                !genericValidationTest(formData.customerName) &&
                submissionAttempted
              }
            />
            <DiliTextCP
              placeholder="Address"
              className="col-md-12 mb-2"
              name="address"
              required
              // minLength={3}
              value={formData.address}
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
              validationTest={genericValidationTest}
              problemText={"Please enter a valid address."}
              showProblemText={
                !genericValidationTest(formData.address) && submissionAttempted
              }
            />
            <DiliTextCP
              placeholder="City"
              className="col-md-6 mb-2"
              name="city"
              required
              // minLength={2}
              value={formData.city}
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
              validationTest={(input) => {
                return genericValidationTest(input, 2);
              }}
              problemText={"Please enter a valid city."}
              showProblemText={
                !genericValidationTest(formData.city, 2) && submissionAttempted
              }
            />
            <DiliTextCP
              placeholder="State"
              className="col-md-2 mb-2"
              type="select"
              name="state"
              required
              // minLength={3}
              value={formData.state}
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
            >
              {statesOptions}
            </DiliTextCP>
            <DiliTextCP
              placeholder="Zip Code"
              className="col-md-4 mb-2"
              pattern="^[0-9]{5}(?:-[0-9]{4})?$"
              maxLength="10"
              name="zip"
              required
              value={formData.zip}
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
              helperText={"55555 ( -5555 )"}
              showHelperText={true}
              validationTest={isValidZipCode}
              problemText={"55555 ( -5555 )"}
              showProblemText={!isValidZipCode(formData.zip)}
              showProblemTextOnlyAfterStartedTyping
            />
          </div>
          <h5>Order Info</h5>
          <div className="form-row">
            {/* <DiliTextCP
            className="col-md-6 mb-2"
            placeholder="Total Parts Cost"
            type="number"
            label="Total Parts Cost"
            onChange={handleChangeForm}
            decimalPrecision={2}
            name="totalPartsCost"
            value={formData.totalPartsCost}
          />
          <DiliTextCP
            className="col-md-6 mb-2"
            placeholder="Total Parts Sale"
            type="number"
            label="Total Parts Sale"
            onChange={handleChangeForm}
            decimalPrecision={2}
            name="totalPartsSale"
            value={formData.totalPartsSale}
          /> */}
            <DiliTextCP
              className="col-md-8 mb-2"
              type="textarea"
              rows="3"
              maxLength="250"
              name="notes"
              onChange={handleChangeForm}
              value={formData.notes}
              label="Notes"
              displayTextAreaCharacterCountNotCol
            />
            <DiliTextCP
              className="col-md-4 mb-2"
              placeholder="Total Value"
              type="number"
              label="Total Value"
              max="100000"
              name="totalValue"
              onChange={handleChangeForm}
              value={formData.totalValue}
              decimalPrecision={2}
            />
          </div>
          <h5>
            Stop Info
            <RequiredStar />
          </h5>
          <div className="row">
            <DiliTextCP
              className="col-lg-6 mb-2 mb-lg-0"
              // label="Stop Type"
              type="select"
              name="stopType"
              value={formData.stopType}
              required
              onChange={handleChangeForm}
              wasSubmitted={submissionAttempted}
              validationTest={selectValidationTest}
              problemText={"Please select a stop type."}
              showProblemText={
                !selectValidationTest(formData.stopType) && submissionAttempted
              }
            >
              <option value="">Select Stop Type</option>
              <option
                value={CXTStopTypes.delivery.value}
                disabled={positionHasDeparted}
              >
                {CXTStopTypes.delivery.display}
              </option>
              <option value={CXTStopTypes.pickup.value}>
                {CXTStopTypes.pickup.display}
              </option>
            </DiliTextCP>
            {stops?.length > 0 && (
              <div className="d-flex gap-4 align-items-center ml-3 ml-lg-0">
                <Form.Check
                  type="radio"
                  name={insertSequenceTypes.first}
                  label="First"
                  checked={
                    formData.insertSequenceType === insertSequenceTypes.first
                  }
                  onClick={handleChangeForm}
                ></Form.Check>
                <Form.Check
                  type="radio"
                  name={insertSequenceTypes.last}
                  label="Last"
                  checked={
                    formData.insertSequenceType === insertSequenceTypes.last
                  }
                  onClick={handleChangeForm}
                ></Form.Check>
                <Form.Check
                  type="radio"
                  name={insertSequenceTypes.specific}
                  label="Specific"
                  checked={
                    formData.insertSequenceType === insertSequenceTypes.specific
                  }
                  onClick={handleChangeForm}
                ></Form.Check>
                {formData.insertSequenceType ===
                  insertSequenceTypes.specific && (
                  <DiliTextCP
                    type="number"
                    min={1}
                    max={stops?.length + 1}
                    name="specificInsertSequence"
                    value={formData.specificInsertSequence}
                    // disabled
                    onChange={handleChangeForm}
                    integerOnly
                  />
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            // onClick={handleSubmitAddManualStopForm}
          >
            Add Stop
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
